"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduleArchivableBackupRow = void 0;
require("@veeam/components/lib/SchedulingMatrix/SchedulingMatrix");
const core_1 = require("../../../core");
const types_1 = require("../types");
const matrixDescriptionRenderer_1 = require("./matrixDescriptionRenderer");
const getScheduleArchivableBackupRow = (value, texts, isVisible, isScheduleArchive) => {
    if (!isVisible) {
        return;
    }
    return {
        key: types_1.SCHEDULE_ROW.third,
        title: isScheduleArchive ? texts.rowArchivedThirdMatrixRowTitle : texts.rowThirdMatrixRowTitle,
        description: matrixDescriptionRenderer_1.matrixDescriptionRenderer({
            textEmpty: isScheduleArchive
                ? texts.rowArchivedThirdMatrixRowEmptyLabel
                : texts.rowThirdMatrixRowEmptyLabel,
            textRenderer: (count) => core_1.parseTextConfig(isScheduleArchive
                ? texts.rowArchivedThirdMatrixRowFilledLabel
                : texts.rowThirdMatrixRowFilledLabel, { count: `${count}` }),
        }),
    };
};
exports.getScheduleArchivableBackupRow = getScheduleArchivableBackupRow;
//# sourceMappingURL=getScheduleArchivableBackupRow.js.map